import "./ShopPage.css";
import headerImage from "../images/ShopPage_header.png";
import arrow from "../images/ShopPage_arrow.svg";
import bookCover from "../images/ShopPage_bookCover.png";

const ShopPage = () => {
    return (
        <>
            <header className="shop-header">
                <img
                    src={headerImage}
                    alt="Shop Header"
                    className="header-image"
                />
                <div className="header-text">
                    <h2 className="shop-label">Shop</h2>
                    <h1 className="shop-title">
                        Bite-Sized Humor, Full-On Merch
                    </h1>
                    <p className="shop-description">
                        From Boba totes to Borscht pun aprons, check out what
                        the CKC closet has to offer and purchase our merch to
                        help support our mission!
                    </p>
                    <p class="shop-view">
                        View our products below{" "}
                        <img src={arrow} alt="Arrow" class="shop-arrow" />{" "}
                    </p>
                </div>
            </header>
            <section class="shop-book-section">
                <div class="shop-book-content">
                    <div class="shop-book-text book-item">
                        <h3 class="shop-book-label">Cooktivity Book</h3>
                        <h2 class="shop-book-title">ABC's of Cooking</h2>
                        <p class="shop-book-description">
                            A collaboration with Dream Dragon Entertainment, Inc
                            An innovative activity cookbook combining the fun of
                            traditional activities with cooking-related topics,
                            such as:
                        </p>
                        <ul class="shop-book-points">
                            <li>Coloring pages</li>
                            <li>Food idioms</li>
                            <li>Crosswords</li>
                            <li>Characters from around the world</li>
                            <li>
                                Do-it-yourself recipes children can customize
                            </li>
                        </ul>
                    </div>
                    <div class="shop-book-link book-item">
                        <p class="shop-book-subtitle">
                            Want a copy of your own?
                        </p>
                        <a
                            href="https://www.thedreamdragon.com/product-page/abc-s-of-cooking-cooktivity-book?gQT=0"
                            class="shop-book-button"
                        >
                            Buy Now
                        </a>
                    </div>
                    <img
                        src={bookCover}
                        alt="ABC's of Cooking book cover"
                        class="shop-book-image book-item"
                    />
                </div>
            </section>
        </>
    );
};

export default ShopPage;
